/* tslint:disable */
/* eslint-disable */
/**
 * Kundenportal-Rest
 * This is the SAF Kundenportal-Rest API
 *
 * The version of the OpenAPI document: 1.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InviteColleaguesForm,
    InviteColleaguesFormFromJSON,
    InviteColleaguesFormToJSON,
    NewUserForm,
    NewUserFormFromJSON,
    NewUserFormToJSON,
    User,
    UserFromJSON,
    UserToJSON,
} from '../models';

export interface CreateUserFromWizardRequest {
    newUserForm?: NewUserForm;
}

export interface GetUserAzureClaimsRequest {
    uid: string;
}

export interface InviteColleaguesRequest {
    inviteColleaguesForm?: InviteColleaguesForm;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     */
    async createUserFromWizardRaw(requestParameters: CreateUserFromWizardRequest): Promise<runtime.ApiResponse<User>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oAuth2", ["ROLE_UNREGISTERED"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/user/wizard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewUserFormToJSON(requestParameters.newUserForm),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     */
    async createUserFromWizard(requestParameters: CreateUserFromWizardRequest): Promise<User> {
        const response = await this.createUserFromWizardRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getUserRaw(): Promise<runtime.ApiResponse<User>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oAuth2", ["ROLE_UNREGISTERED", "ROLE_USER", "ROLE_ADMINISTRATOR", "ROLE_SAF"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     */
    async getUser(): Promise<User> {
        const response = await this.getUserRaw();
        return await response.value();
    }

    /**
     */
    async getUserAzureClaimsRaw(requestParameters: GetUserAzureClaimsRequest): Promise<runtime.ApiResponse<{ [key: string]: object; }>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling getUserAzureClaims.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.uid !== undefined) {
            queryParameters['uid'] = requestParameters.uid;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oAuth2", ["ROLE_SYSTEM"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/user/azure/claims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getUserAzureClaims(requestParameters: GetUserAzureClaimsRequest): Promise<{ [key: string]: object; }> {
        const response = await this.getUserAzureClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async inviteColleaguesRaw(requestParameters: InviteColleaguesRequest): Promise<runtime.ApiResponse<User>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oAuth2", ["ROLE_ADMINISTRATOR", "ROLE_SAF"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/user/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteColleaguesFormToJSON(requestParameters.inviteColleaguesForm),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     */
    async inviteColleagues(requestParameters: InviteColleaguesRequest): Promise<User> {
        const response = await this.inviteColleaguesRaw(requestParameters);
        return await response.value();
    }

}
